import WbHttpClient from './../../services/wbhttpclient';

export default class WsPermissionServie extends WbHttpClient {

    public async getWsDetails(teamId: string, wsId: string) {

        let url = "activity/WsPermissionUserList" + "?tid=" + teamId + "&wsId=" + wsId + "&json=true";
        return await this.get(url);
    }

    public async getSerachUserList(params = {}) {
        const value = await this.get('/team/searcUserListsForAllMyTeams', params);
        return value.data;
    }

    public async saveWorkstreamAccess(params = {}) {
        return await this.post('/activity/saveWorkstreamAccess', params);
    }
    public async getTeamUserList(params = {}) {
        return await this.post('/meeting/getTeamUserDetailsForMeeting', params);
    }
}